import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const selectedMixin = (theme, selected, $focused) => selected ? css(["outline:none;background-color:", ";box-shadow:inset ", " 0 0 ", ";"], theme.dropdown.item.bgActive, theme.dropdown.item.borderWidthActive, theme.dropdown.item.borderActive) : css(["background-color:", ";:hover{background-color:", ";}", ""], theme.dropdown.item.bg, theme.dropdown.item.bgHover, $focused && css(["background-color:", ";"], theme.dropdown.item.bgHover));
const disabledMixin = (theme, disabled) => disabled && css(["color:", ";:hover{background-color:", ";}cursor:not-allowed;"], theme.dropdown.item.colorDisabled, theme.dropdown.item.bg);
const noWrapMixin = noWrap => noWrap && css(["white-space:nowrap;margin-right:6px;"]);
const ItemMixin = /*#__PURE__*/css(["color:", ";", " ", " ", ""], ({
  theme
}) => theme.dropdown.item.color, ({
  theme,
  selected,
  $focused
}) => selectedMixin(theme, selected, $focused), ({
  theme,
  disabled
}) => disabledMixin(theme, disabled), ({
  noWrap
}) => noWrapMixin(noWrap));
const RenderWrapper = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-30074613__sc-1a042f9-0"
})(["display:flex;align-items:center;padding:1px 11px 0px 11px;", ""], ItemMixin);
const SelectButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-30074613__sc-1a042f9-1"
})(["background-color:transparent;cursor:pointer;border:0;:focus{outline:none;}", ";text-align:start;position:relative;width:100%;min-height:", ";display:list-item;list-style-type:none;", ""], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.dropdown.item.minHeight, isMobile(css(["", ";min-height:", ";", ""], ({
  theme
}) => theme.typography.mobile.base, ({
  theme
}) => theme.dropdown.item.mobile.minHeight, ({
  theme,
  selected
}) => selected && `box-shadow: inset 3px 0 0 ${theme.dropdown.item.borderActive};`)));
const StandaloneSelectButton = /*#__PURE__*/styled(SelectButton).withConfig({
  componentId: "sc-storm-ui-30074613__sc-1a042f9-2"
})(["&&{padding:1px 11px 0px 11px;}", ""], ItemMixin);

export { RenderWrapper as R, SelectButton as S, StandaloneSelectButton as a };
//# sourceMappingURL=SelectOption.styles-CwBRn_zM.js.map
